import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function tvaIntracommunautaireValidator(): ValidatorFn {
  // FR + 2 chiffres + optionnel espace + 9 chiffres => total 11 chiffres après "FR"
  const re = /^FR\d{2}\s?\d{9}$/i;
  return (control: AbstractControl): ValidationErrors | null => {
    const val: string = control.value;
    if (val == null || val === '') return null;
    return re.test(val)
      ? null
      : {
          tvaIntra: true,
        };
  };
}
